module.exports = __webpack_public_path__ + "static/virtual-reality-society-for-neuroscience-8b3b9253e1556c24a0912f6612a13118.jpg";